<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="hxFtyNoticeInCode"
      border
      resizable
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{ highlight: true, reserve: true }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
      @cell-click="cellClick"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.hxFtyNoticeInStatus == 'Y'
              ? 'success'
              : row.hxFtyNoticeInStatus == 'F'
              ? 'info'
              : row.hxFtyNoticeInStatus == 'S'
              ? 'warning'
              : row.hxFtyNoticeInStatus == 'D'
              ? 'danger'
              : ''
          "
        >
          {{ row.v_hxFtyNoticeInStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="
                  opt.disabled == undefined ? false : opt.disabled(row)
                "
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
    <chooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{ templateGroup: 'ecom-hxwarehousgeneralbook' }"
      :exportOptions="{
        params: {
          hxFtyNoticeInCode: chooseTemplateOptions.hxFtyNoticeInCode,
        },
      }"
    />
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import chooseTemplate from '@/views/ecom/components/choose-template'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
import { format } from '@/libs/util.number.js'
export default {
  components: { chooseTemplate },
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      chooseTemplateOptions: { visible: false, hxFtyNoticeInCode: '' },
      format: (number) => format(number),
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      const { hxFtyNoticeInCode, hxFtyNoticeInNo, hxFtyNoticeInStatus } = data
      switch (menuType) {
        case 'detail':
        case 'edit':
        case 'send':
        case 'confirm':
        case 'adjust':
          this.$emit('openEditPage', {
            pageType: menuType,
            params: { hxFtyNoticeInCode, hxFtyNoticeInStatus },
            query: { hxFtyNoticeInNo },
          })
          break
        case 'delete':
          this.del(data)
          break
        case 'printer':
          this.printer(data)
          break
        case 'export':
          this.export(data)
          break
      }
    },
    checkboxChange({ records, reserves }) {
      this.$emit('checkboxChange', records.concat(reserves))
    },
    clearCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkboxChange', [])
    },
    cellClick({ row, column }) {
      const { property } = column
      const filterColumns = ['checkbox', 'col-opt', 'hxFtyNoticeInStatus']
      if (filterColumns.includes(property)) return

      const $table = this.$refs.table
      $table.toggleCheckboxRow(row)
      const data = $table.getCheckboxRecords(true)
      const reserves = $table.getCheckboxReserveRecords(true)
      this.$emit('checkboxChange', data.concat(reserves))
    },
    async del({ hxFtyNoticeInCode }) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .ecomHxFtyNoticeInDelApi({ hxFtyNoticeInCode })
        .catch(() => false)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
    printer({ hxFtyNoticeInCode, hxFtyNoticeInNo, scmName }) {
      if (!hxFtyNoticeInCode) return
      const now = new Date().getTime()
      this.$api.globalExportData(
        '/ecom/hx/fty/notice/in/print',
        { hxFtyNoticeInCode },
        `${hxFtyNoticeInNo}_入库通知书_${scmName}_标签_${now}.pdf`
      )
    },
    export({ hxFtyNoticeInCode }) {
      if (!hxFtyNoticeInCode) return
      this.chooseTemplateOptions = { visible: true, hxFtyNoticeInCode }
    },
  },
}
</script>
